import { DropDownRowComponent } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIDataModel } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { UIComponentView } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { ToneOptionDropDownRowViewImpl } from './toneoptiondropdownrowview';


export class ToneOptionDropDownRowComponent extends DropDownRowComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneOptionDropDownRowViewImpl(applicationContext, uiComponentHandler);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneoptions/toneoptiondropdownrowcomponent.tsx